/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";

import YesNoAction from "../../../components/YesNoAction";
import TestIds from "../../../testIds";
import { URLS } from "../../../util/consts";

const NoPastProducts = () => {
  function onClickFindStore() {
    window.open(URLS.findStore, "_blank");
  }

  function onClickAllProducts() {
    window.open("/products?tab=0", "_self");
  }

  return (
    <div data-testid={TestIds.feat.product.list.noProducts}>
      <YesNoAction
        bodyProps={{ sx: { mb: 3 } }}
        body="You do not currently have any past products to show. Once you order with Farmlands the products from your orders will be displayed here."
        optionA={{
          label: "Shop all products",
          onClick: onClickAllProducts,
        }}
        optionB={{
          label: "Find a store",
          onClick: onClickFindStore,
        }}
      />
    </div>
  );
};

export default NoPastProducts;
